import { createContext } from 'use-context-selector'
import { OrganizationOverviewContextProps } from './types'

export const OrganizationOverviewContext = createContext(
  {} as OrganizationOverviewContextProps
)
